import Vue from "vue";
import Component from "vue-class-component";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import { Prop } from "vue-property-decorator";

@Component({ name: "InfoRequestCta" })
export default class InfoRequestCta extends Vue {
    @Prop() readonly ctaType: string;
    @Prop() readonly analytics: string;
    @Prop() readonly message: string;

    public openInfoRequest() {
        this.$store.commit("infoRequestStore/setMessage", this.message);
        this.$store.commit("infoRequestStore/setInfoRequestVisible", true);
    }

    public setAnalytics() {

        switch (this.analytics) {
            case "form":
                GTagHelper.sendEvent("click", "info_request");
                break;
            default:
                GTagHelper.sendEvent("click", "info_request", "update_availability");
                break;
        }
    }
};